import { Current } from 'current.js'

window.Current = Current
